import Api from '../Base'

class GetSpacePlanById extends Api {
  requestUrl = `/api/SpacePlan/${this.getParams().id}`
}
export default GetSpacePlanById
